module.exports = __webpack_public_path__ + "static/img/mrt_logo.9497470.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/mrt_logo.png
// module id = 1f7O
// module chunks = 1